import React, { useState } from "react";
import "./Changelanguage.scss";
import ChangelanguageImage from "../../Assets/lang.png";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import i18n from "../../Shared/Utils/languageStore";
import { useLanguage } from "../ChangeLanguage/LanguageProvider";

function Changelanguage() {
  const { t } = useTranslation("ChangeLanguage");
  const languages = [
    { name: "English", code: "en", id: 1 },
    { name: "मराठी", code: "mr", id: 2 },
  ];
  const { selectedLanguageId, setSelectedLanguageId } = useLanguage();
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const changeLanguage = (lang) => {
    setSelectedLanguage(lang);
  };

  const changeLanguageId = (lang) => {
    setSelectedLanguageId(lang);
  };

  const applyTranslation = () => {
    const lang = selectedLanguage;
    i18n.changeLanguage(lang).then(() => {});
  };

  return (
    <>
      <div
        className="mt-4 p-6 border-round-xl"
        style={{ backgroundColor: "#FFFFFF" }}
      >
      <div className="externalframe">
        <div className="changelanguageframe"></div>
        <div className="frame">
          <div>
            <div className="flex flex-row innerframe">
              <img className="image" src={ChangelanguageImage} alt="" />
              <div>
                <div
                  style={{ minWidth: "429.3px", maxWidth: "429.3px" }}
                  className="width: 27.3125rem height: 6.875rem gap: 2.625rem"
                >
                  <div className="width: 26.875rem height: 2.75rem">
                    <h1 className="preferedlanguage">
                      {t("Select Preferred Language")}
                    </h1>
                  </div>
                  <div>
                    <p className="paragraph">
                      {t(
                        "For a smoother and personal experience, please select your preferred language"
                      )}
                    </p>
                  </div>
                  <div className="buttonanddropdown">
                    <div className="dropdown">
                      <Dropdown
                        optionLabel="name"
                        options={languages}
                        value={languages.find(
                          (lang) =>
                            lang.code === selectedLanguage &&
                            lang.id === selectedLanguageId
                        )}
                        onChange={(e) => {
                          changeLanguage(e.value.code);
                          changeLanguageId(e.value.id);
                        }}
                        placeholder={t("Select Language")}
                        className="w-full md:w-27.3125 h-3"
                      />
                    </div>
                    <div className="button1">
                      <Button
                        label={t("Change Language")}
                        onClick={applyTranslation}
                        className="button"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}

export default Changelanguage;
